import { flow, Instance, SnapshotIn, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { Protection } from './models/Protection';
import { getEnvironment } from './utils';

const identifier = 'protectionId';

export const ProtectionStore = types
  .compose(
    getBaseStore<Instance<typeof Protection>, Instance<typeof Protection>>(Protection, identifier, 'protection'),
    types.model('ProtectionStore', {}),
  )
  .actions((self) => {
    const env = getEnvironment(self);

    const saveProtection = flow(function*(protection: Instance<typeof Protection>) {
      const res = yield self.saveElement(protection);
    });

    const loadActiveList = flow(function*(options?: any) {
      const storeName = self['$treenode']['_subpath'];
      console.log('START LOADING STORE ' + storeName + ' [' + new Date() + ']');
      const res: any = yield env.api.get('Protection/active', {
        ...options,
        params: { ...(options || {}).params },
      });
      let resultIds;
      if (res !== null) {
        self.setDatasFromArray(res!);
        resultIds = res!.map((r) => r[identifier]);
      }
      const result = self.dataList.filter((d) => resultIds.indexOf(d[identifier]) >= 0);
      return result;
    });

    return {
      afterAttach: flow(function*() {
        yield self.loadList();
      }),
      saveProtection,
      loadActiveList,
    };
  });

export type ProtectionStoreType = Instance<typeof ProtectionStore>;
